import { Component, Show, onMount } from "solid-js";
import { createStore } from "solid-js/store";
import { SalonSubmissionAwardGrouping } from "../Types";
import { loadCms } from "../app";
import { CMS } from "./cms/cms";
import { RawHtml } from "./raw-html";
import { DisplayArtwork } from "./display-artwork";
import { cleanTargetName } from "../library/common";

type Props = {
    baseAwardName: string;
    model: SalonSubmissionAwardGrouping[];
    content?: {
        id: string;
        text: string;
    }
}
type State =  {
    isContentReady: boolean;
}

export const RunnerUp : Component<Props> = (props) => {
    const [state, setState] = createStore<State>({ isContentReady: false });
    const best = props.model.find(x => x.Award == props.baseAwardName);
    const runnerUp = props.model.find(x => x.Award == props.baseAwardName + " Runner Up");
    //const prize = best?.Prizes?.find(x=> x.Award == best?.Award?.Id);
    onMount(async() => {
        if (props.content?.id) {
            await loadCms([props.content.id]);
        }
        setState({ isContentReady: true });
    })
    return (
        <>
            <Show when={state.isContentReady}>
                <Show when={best}>
                    <div class="divider">
                        <a name={cleanTargetName(props.baseAwardName)}></a>
                        <h1 style="text-align: center;">
                            {props.baseAwardName}
                        </h1>
                        <Show when={props.content}>
                            <Show when={props.content?.id}>
                                <div class="container">
                                    <CMS id={props.content!.id}>{props.content?.text}</CMS>
                                </div>
                            </Show>
                            <Show when={!props.content?.id}>
                                <div class="container">
                                    <RawHtml value={props.content?.text || ""} />
                                </div>
                            </Show>
                        </Show>
                    </div>
                    <div style="background-color: #333;">
                        <div class="grid runner-up-grid">
                            <div class="grid-sizer"></div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="pull-right">
                                        <DisplayArtwork
                                            name={props.baseAwardName}
                                            isBest={true}
                                            artwork={best!.Items[0]} />
                                    </div>
                                </div>
                                <Show when={runnerUp}>
                                    <div class="col-md-6">
                                        <DisplayArtwork
                                            name={props.baseAwardName + " Runner Up"}
                                            isBest={false}
                                            artwork={runnerUp!.Items[0]} />
                                    </div>
                                </Show>
                            </div>
                        </div>
                    </div>
                </Show>
            </Show>
        </>
    )
}
